﻿function filterCompanies(event) {
    event.preventDefault();
    const search = $(event.currentTarget).val();
    $("[data-company-name]").each(function (index, element) {
        const link = $(element);
        const companyName = link.data('company-name');
        if (companyName.toLowerCase().indexOf(search.toLowerCase()) > -1) {
            $(this).removeClass('d-none');
        } else {
            $(this).addClass('d-none');
        }
    });
}

function format(id, tr) {
    var jqXHR = $.ajax({
        url: `/fleet200-company/get/${id}`,
        type: 'GET',
        async: false
    });
    const obj = JSON.parse(jqXHR.responseText);
    if (obj[0].name1 === "" &&
        obj[0].name3 === "" &&
        obj[0].name3 === "" &&
        obj[0].name4 === "" &&
        obj[0].name5 === "") {
        //show nothing
    } else {
        var returnText = "<div class='padding-left-75 padding-right-75'>";
        if (obj[0].name1 !== "") {
            returnText += "<div class='company-person'><div>";
            returnText += obj[0].name1;
            if (obj[0].jobTitle1 !== "") {
                returnText += "</br>" + obj[0].jobTitle1;
            }
            returnText += "</div></div>";
        }
        if (obj[0].name2 !== "") {
            returnText += "<div class='company-person'><div>";
            returnText += obj[0].name2;
            if (obj[0].jobTitle2 !== "") {
                returnText += "</br>" + obj[0].jobTitle2;
            }
            returnText += "</div></div>";
        }
        if (obj[0].name3 !== "") {
            returnText += "<div class='company-person'><div>";
            returnText += obj[0].name3;
            if (obj[0].jobTitle3 !== "") {
                returnText += "</br>" + obj[0].jobTitle3;
            }
            returnText += "</div></div>";
        }
        if (obj[0].name4 !== "") {
            returnText += "<div class='company-person'><div>";
            returnText += obj[0].name4;
            if (obj[0].jobTitle4 !== "") {
                returnText += "</br>" + obj[0].jobTitle4;
            }
            returnText += "</div></div>";
        }
        if (obj[0].name5 !== "") {
            returnText += "<div class='company-person'><div>";
            returnText += obj[0].name5;
            if (obj[0].jobTitle5 !== "") {
                returnText += "</br>" + obj[0].jobTitle5;
            }
            returnText += "</div></div>";
        }
        returnText += "</div>";
        $(tr).find('.more-button').addClass('active');
        $("<div class='details' style=''>" + returnText + "</div>").insertAfter(tr);
    }
    
}

export function setupCompanySearch() {
    $("#myTable").tablesorter({
        sortInitialOrder: 'desc',
        sortList: [[5, 1]],
        widgets: ["zebra"]
    });
    $("#myTable").bind("sortBegin", function (e, table) {
        $('.details').remove();
        $('.more-button').removeClass('active');
    });

    $(document).on("keyup", "[data-company-search]", filterCompanies);

    $(document).on("click", ".more-button", function (e) {
        e.preventDefault();
        var tr = $(this).closest('tr');
        var selectedRow = $(this);
        var itemId = selectedRow.data('item-id');
        var next = tr.next();
        var className = next.attr('class');
        if (className !== "details") {
            format(itemId, tr);
            $(this).closest('tr').next().next().find('td').css('padding-top', '80px');
        } else {
            $(this).closest('tr').next().next().find('td').css('padding-top', '10px');
            $(next).remove();
            $(tr).find('.more-button').removeClass('active');
            
        }
    });
}